import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import theme from '../../../styles/theme';

const featherIcon = require('feather-icons');

const IconWrapper = styled.i`
  display: inline-block;
`;

const Icon = ({ name, size, strokeWidth, rotate, color, ...props }) => {
  const iconType = {
    primary: theme.colors.primary,
    dark: theme.colors.gray700,
    white: theme.colors.white,
  };

  const shapeStyle = {
    width: size,
    height: size,
    transform: rotate ? `rotate(${rotate}deg)` : undefined,
  };

  const iconStyle = {
    strokeWidth,
    stroke: Object.keys(iconType).includes(color) ? iconType[color] : color,
    width: size,
    height: size,
    color: Object.keys(iconType).includes(color) ? iconType[color] : color,
  };

  const icon = featherIcon.icons[name];
  const svg = icon ? icon.toSvg(iconStyle) : '';
  const base64 = Buffer.from(svg, 'utf8').toString('base64');

  return (
    <IconWrapper {...props} style={{ ...shapeStyle, ...props.style }}>
      <img src={`data:image/svg+xml;base64,${base64}`} alt={name} />
    </IconWrapper>
  );
};

Icon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  rotate: PropTypes.number,
  color: PropTypes.string,
  style: PropTypes.object,
};

Icon.defaultProps = {
  name: 'bell',
  size: theme.iconSizes.s,
  strokeWidth: 2,
  rotate: 0,
  color: 'dark',
  style: {},
};

export default Icon;
